import { useTranslation } from 'react-i18next'
import Button from './Button'
import type { AttachmentPreviewState } from '../../lib/useAttachmentPreview'

interface Props {
  preview: AttachmentPreviewState
  /** "Listeye dön" — paneli kapatır; durum ve object URL ömrü `useAttachmentPreview`'dadır. */
  onBack: () => void
}

/**
 * Dosya ekinin pop-up **içindeki** önizleme paneli (108) — üstte "Listeye dön" + dosya adı, altında
 * içerik.
 *
 * <p>Panel, açıldığı pop-up'ta listenin <b>yerini alır</b> — yan yana koymak dar ekranda iki alanı da
 * okunmaz yapardı. Bu bileşen yalnız <b>çizer</b>: hangi satırın önizlenebilir olduğuna
 * {@link previewKindOf}, blob'un ömrüne {@link useAttachmentPreview} karar verir.
 *
 * <p><b>Her dosya önizlenemez</b> — yalnız PDF ve görseller; Office/arşiv satırlarında göz ikonu hiç
 * çizilmez ({@link AttachmentTable}).
 */
export default function AttachmentPreviewPanel({ preview, onBack }: Readonly<Props>) {
  const { t } = useTranslation()
  return (
    <div className="ui-att-preview">
      <div className="ui-att-preview-bar">
        <Button
          variant="secondary"
          icon="pi pi-arrow-left"
          label={t('common.filePreview.backToList')}
          onClick={onBack}
        />
        <span className="ui-att-preview-name" title={preview.fileName}>
          {preview.fileName}
        </span>
      </div>
      {preview.kind === 'pdf' ? (
        // `title` erişilebilirlik için zorunlu (iframe'in erişilebilir adı); dosya adı taşınır.
        <iframe className="ui-att-preview-frame" src={preview.url} title={preview.fileName} />
      ) : (
        <img className="ui-att-preview-image" src={preview.url} alt={preview.fileName} />
      )}
    </div>
  )
}
